import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { HeaderService } from 'src/app/services/header/header.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: false
})
export class MainComponent implements OnInit {

  nameWindow: string = 'Inicio';
  projectName = ProjectName.projectName;

  constructor(private title: Title,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.title.setTitle(this.nameWindow + ' - ' + this.projectName);

    this.headerService.setTitle('Cervino');
    this.headerService.setIcon('pi pi-home');
  }

}
